/**
  Función que devuelve un numero aleatorio en string, por defecto entre 100000 y 999999 incluidos

  @param object options - opciones para modificar el comportamiento por defecto

  @options.prefix string cadena que se pega al principio del valor devuelto
  @options.suffix string cadena que se pega al final del valor devuelto
  @options.min number minimo incluido
  @options.max number maximo no incluido

  @return string

  @example rnd() = rnd({min:100000, max:1000000}) => "100000"-"999999"
  @example rnd({min:0, max:10}) => "0"-"9"
  @example rnd({prefix: 'prefijo_', suffix: '_sufijo'}) = "prefijo_["100000"-"999999"]_sufijo"
*/

export function rnd(options = {}) {
  const { prefix = '', suffix = '', min = 100000, max = 1000000 } = options;
  return prefix + (Math.floor(Math.random() * (max - min)) + min) + suffix;
}
